module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.6@readable-stream/lib/internal/streams/stream-browser.js
// module id = +WtB
// module chunks = 0